import { useQuery } from '@tanstack/react-query';
import { BannerModel } from '../../types';
import { getPromoSliderData } from '@http/endpoints/home';

type usePromoSliderQueryModel = {
  banners: BannerModel[];
  isLoading: boolean;
  isFetched?: boolean
};

const usePromoSliderQuery = (isBannersFetched = false): usePromoSliderQueryModel => {
  const { data, isLoading, isFetched } = useQuery(['promo-slider-query'], getPromoSliderData, {
    enabled: !!isBannersFetched
  });

  const banners = data?.data;

  return { banners, isLoading, isFetched };
};

export default usePromoSliderQuery;
